import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { supabase } from '../../supabase';

function SuperAdminPrivateRoute() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check Supabase auth state
    const checkAuth = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (user) {
          setIsAuthenticated(true);
        } else {
          // If Supabase auth fails, check localStorage fallback
          const localAuth = localStorage.getItem('isSuperAdminAuthenticated');
          setIsAuthenticated(localAuth === 'true');
        }
      } catch (error) {
        console.error('Auth check error:', error);
        // Fallback to localStorage check
        const localAuth = localStorage.getItem('isSuperAdminAuthenticated');
        setIsAuthenticated(localAuth === 'true');
      }
      setLoading(false);
    };

    checkAuth();

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (session?.user) {
        setIsAuthenticated(true);
      } else {
        const localAuth = localStorage.getItem('isSuperAdminAuthenticated');
        setIsAuthenticated(localAuth === 'true');
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: '#f5f5f5'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontSize: '2rem', 
            marginBottom: '1rem',
            animation: 'spin 1s linear infinite'
          }}>⚙️</div>
          <p style={{ color: '#666', fontSize: '1.1rem' }}>Loading Super Admin Portal...</p>
        </div>
        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }
  
  // If not authenticated, redirect to super admin login page
  if (!isAuthenticated) {
    return <Navigate to="/superadmin" replace />;
  }

  // If authenticated, render the child routes
  return <Outlet />;
}

export default SuperAdminPrivateRoute;

